<template>
  <div>
    <GenerateInvoicePanel ref="generateInvoicePanel" @updateBilling="loadBillings()" @updateOtherInvoices="loadOtherInvoices()" />

    <v-flex xs12>
      <div class="elevation-1 text-center paper mb-1">
        <v-tabs v-model="tab">
          <v-tabs-slider></v-tabs-slider>

          <v-tab class="tab">
            {{ $t('income.billing.invoices.tabTitle') }}
          </v-tab>
          <v-tab class="tab">
            {{ $t('income.billing.otherInvoices.tabTitle') }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" style="width: 100%;">
          <!-- // *Factura venta mostrador -->
          <v-tab-item>
            <div class="d-flex flex-column py-4">
              <div class="d-flex justify-end mb-4">
                <div class="d-flex align-row linkButton" v-if="billingPermissions['create-posSales']">
                  <v-btn
                    fab
                    x-small
                    depressed
                    color="primary"
                    @click="createBilling()"
                    class="mr-1 elevation-3"
                    >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <div class="my-auto">
                    <a @click="createBilling()">
                      {{ $t('income.billing.invoices.buttonGetSales') }}
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <v-data-table
                  :loading-text="tableInvoices.loadingText"
                  :loading="tableInvoices.loading"
                  :headers="tableInvoices.headers"
                  :items="tableInvoices.data"
                  :options="tableInvoices.options"
                  hide-default-footer
                  class="tableBilling"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{ $moment(item.date).format('MMMM') }}
                  </template>
                  <template v-slot:[`header.sale`]="{ header }">
                    <div class="text-right">{{ header.text }}</div>
                  </template>
                  <template v-slot:[`item.sale`]="{ item }">
                    <div class="text-right">{{ formatCurrency(item.saleTotal) }}</div>
                  </template>
                  <template v-slot:[`header.cancellationByPlatformTotal`]="{ header }">
                    <div class="text-right">{{ header.text }}</div>
                  </template>
                  <template v-slot:[`item.cancellationByPlatformTotal`]="{ item }">
                    <div class="text-right">{{ formatCurrency(item.cancellationByPlatformTotal) }}</div>
                  </template>
                  <template v-slot:[`header.collectionInvoices`]="{ header }">
                    <div class="text-right">{{ header.text }}</div>
                  </template>
                  <!-- <template v-slot:[`item.collectionInvoices`]="{ item }">
                    <div class="text-right">{{ formatCurrency(item.chargeCommisionTotal) }}</div>
                  </template> -->
                  <template v-slot:[`header.invoiceClients`]="{ header }">
                    <div class="text-right">{{ header.text }}</div>
                  </template>
                  <template v-slot:[`item.invoiceClients`]="{ item }">
                    <div class="d-flex align-center justify-end">
                      <v-edit-dialog
                        :return-value.sync="item.customerInvoicedTotal"
                        large
                        dark
                        persistent
                        @save="updateCustomerInvoicedTotal(item._id, item.customerInvoicedTotal)"
                        cancel-text="Cancelar"
                        save-text="Guardar">
                        ${{ (item.customerInvoicedTotal || 0) | toFixNumber(2) | numberWithComma }}
                        <v-icon light small>mdi-border-color</v-icon>
                        <template v-slot:input>
                          <v-text-field
                            v-model.number="item.customerInvoicedTotal"
                            label="Edit"
                            single-line>
                          </v-text-field>
                        </template>
                      </v-edit-dialog>
                      <!-- <v-text-field
                        v-show="item.isEditing"
                        v-model.lazy="$v.billingForm.customerInvoicedTotal.$model"
                        type="number"
                        :error-messages="customerInvoicedTotalErrors"
                        @blur="updateCustomerInvoicedTotal(item._id)"
                        rounded
                        outlined
                        dense
                        class="mt-7"
                      />
                      <div v-show="!item.isEditing" class="text-right">
                        {{ formatCurrency(item.customerInvoicedTotal) }}
                      </div>
                      <div>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              color="primary"
                              @click="setCustomerInvoiceTotalEditOn(item.customerInvoicedTotal, item)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('income.billing.invoices.tableInvoices.buttonEditTooltip') }}</span>
                        </v-tooltip>
                      </div> -->
                      <!-- // Todo: integrate upload csv -->
                      <div v-if="!item.customerInvoicedTotalFile" class="ml-3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              fab
                              x-small
                              depressed
                              @click="openUploadDialog(item._id)"
                              color="primary"
                            >
                              <v-icon>mdi-file-upload-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('income.billing.invoices.tableInvoices.buttonUploadCsvTooltip') }}</span>
                        </v-tooltip>
                      </div>
                      <div v-else>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              fab
                              x-small
                              dark
                              depressed
                              target="_blank"
                              :href="downloadLink(item)"
                              color="secondary"
                            >
                              <v-icon color="white">mdi-file-download-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('income.billing.invoices.tableInvoices.buttonDownloadCsvTooltip') }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`header.globalInvoice`]="{ header }">
                    <div class="text-right">{{ header.text }}</div>
                  </template>
                  <template v-slot:[`item.globalInvoice`]="{ item }">
                    <div class="text-right">{{ formatCurrency(item.invoicePosTotal) }}</div>
                  </template>
                  <template v-slot:[`item.generate`]="{ item }">
                    <div v-if="!isEmpty(item.invoice)">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            fab
                            x-small
                            depressed
                            color="primary"
                            @click="openInvoice(item.invoice)"
                          >
                            <v-icon>mdi-receipt</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver factura</span>
                      </v-tooltip>
                    </div>
                    <div v-else class="d-flex align-row linkButton" >
                      <v-btn
                        v-if="billingPermissions['generate-global-invoice']"
                        fab
                        x-small
                        depressed
                        :plain="true"
                        :ripple="false"
                        color="primary"
                        @click="openGenerateInvoicePanel(item)"
                        class="mr-1"
                        >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <div class="my-auto" v-if="billingPermissions['generate-global-invoice']">
                        <a @click="openGenerateInvoicePanel(item)">
                          {{ $t('income.billing.invoices.tableInvoices.buttonGenerate') }}
                        </a>
                      </div>
                      <div>
                        <v-tooltip top  v-if="billingPermissions['update-posSale']">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              fab
                              x-small
                              depressed
                              color="secondary"
                              @click="refreshPosSale(item._id)"
                            >
                              <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                          </template>
                          <span>Actualizar venta a mostrador</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-tab-item>

          <!-- // *Otras facturas -->
          <v-tab-item style="width: 100%;">
            <div class="d-flex flex-column py-4">
              <div class="d-flex justify-space-between mb-4">
                <div>
                  <DateRangeInput :selectedDates="selectedDates" @update="updateDates" />
                </div>
                <div class="d-flex align-row linkButton" v-if="billingPermissions['generate-document']">
                  <v-btn
                    fab
                    x-small
                    depressed
                    color="primary"
                    @click="openGenerateInvoicePanel()"
                    class="mr-1 elevation-3"
                    >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <div class="my-auto">
                    <a @click="openGenerateInvoicePanel()">
                      {{ $t('income.billing.otherInvoices.buttonGenerate') }}
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <v-data-table
                  :loading-text="tableOtherInvoices.loadingText"
                  :loading="tableOtherInvoices.loading"
                  :headers="tableOtherInvoices.headers"
                  :items="tableOtherInvoices.data"
                  :options="tableOtherInvoices.options"
                  hide-default-footer
                  class="tableBilling"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{ $moment(item.issuedAt).format('MMMM') }}
                  </template>
                  <template v-slot:[`item.client`]="{ item }">
                    <div>{{ item.receiverTaxid }}</div>
                  </template>
                  <template v-slot:[`header.amount`]="{ header }">
                    <div class="text-right">{{ header.text }}</div>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <div class="text-right">{{ formatCurrency(item.total) }}</div>
                  </template>
                  <template v-slot:[`item.category`]="{ item }">
                    <div>{{ getCategoryName(item.incomeType ? item.incomeType._id : undefined) }}</div>
                  </template>
                  <template v-slot:[`item.support`]="{ item }">
                    <div v-if="item.source === 'facturapi'">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            fab
                            x-small
                            depressed
                            color="primary"
                            @click="openInvoice(item.invoice || item)"
                          >
                            <v-icon>mdi-receipt</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver factura</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div v-if="item.source === 'receipt'">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            fab
                            x-small
                            depressed
                            color="blueButton"
                            target="_blank"
                            :href="downloadInvoice(item._id)"
                          >
                            <v-icon>mdi-download</v-icon>
                          </v-btn>
                        </template>
                        <span>Descargar factura</span>
                      </v-tooltip>
                    </div>
                    <div v-if="item.paidStatus === 'not-paid'">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            fab
                            x-small
                            depressed
                            color="blueButton"
                            target="_blank"
                            @click="markAsPaid(item._id)"
                          >
                            <v-icon>mdi-currency-usd</v-icon>
                          </v-btn>
                        </template>
                        <span>Marcar como pagada</span>
                      </v-tooltip>
                    </div>
                  </template>

                  <template v-slot:footer="">
                    <Pagination
                      :itemsPerPage="tableOtherInvoices.options.itemsPerPage"
                      :page="tableOtherInvoices.options.page"
                      :total="totalRecords"
                    />
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-flex>

    <!-- // Todo: integrate csv upload -->
    <!-- <UploadFileDialog :dropzoneProps="{ '@vdropzone-success': vdropzoneSuccess() }" /> -->
    <UploadFileDialog :dropzoneOptions="{ acceptedFiles: '.csv' }" @uploadFile="uploadFile" ref="uploadFileDialog" />
    <InvoiceViewer ref="invoiceViewer" />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import { validationMixin } from 'vuelidate'
import { required, decimal, minValue } from 'vuelidate/lib/validators'

// Todo: integrate csv upload
import UploadFileDialog from '@/components/modals/UploadFileDialog'
import formatCurrency from '@/utils/formatCurrency'
import GenerateInvoicePanel from '@/components/sidePanels/GenerateInvoice'
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import DateRangeInput from '@/components/elements/DateRangeInput'
import Pagination from '@/components/elements/Pagination'

export default {
  name: 'Billing',
  components: {
    GenerateInvoicePanel,
    UploadFileDialog, // Todo: integrate csv upload
    InvoiceViewer,
    DateRangeInput,
    Pagination
  },
  mixins: [validationMixin],
  validations: {
    billingForm: {
      customerInvoicedTotal: { required, decimal, minValue: minValue(0) }
    }
  },
  data () {
    return {
      overlay: false,
      tab: 0,
      tableInvoices: {
        loadingText: this.$i18n.t('income.billing.invoices.tableInvoices.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.date'), value: 'date', sortable: false },
          { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.sale'), value: 'sale', sortable: false },
          // { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.collectionDirect'), value: 'collectionDirect', sortable: false },
          { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.cancellationByPlatformTotal'), value: 'cancellationByPlatformTotal', sortable: false },
          // { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.collectionInvoices'), value: 'collectionInvoices', sortable: false },
          { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.invoiceClients'), value: 'invoiceClients', sortable: false },
          { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.globalInvoice'), value: 'globalInvoice', sortable: false },
          { text: this.$i18n.t('income.billing.invoices.tableInvoices.headers.generate'), value: 'generate', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: -1,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      isCustomerInvoiceTotalEditOn: false,
      billingForm: {
        customerInvoicedTotal: 0
      },
      tableOtherInvoices: {
        loadingText: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.date'), value: 'date', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.client'), value: 'client', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.amount'), value: 'amount', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.category'), value: 'category', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.support'), value: 'support', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      categories: [],
      selectedDates: [],
      selectedPos: null
    }
  },
  mounted: function () {
    this.loadCategories()
    this.loadBillings()
    // Todo: set default dates
    // this.setDefaultDates()
  },
  watch: {
    tab: function () {
      if (this.tab === 0) {
        this.loadBillings()
      } else if (this.tab === 1) {
        this.loadOtherInvoices()
      }
    }
  },
  computed: {
    customerInvoicedTotalErrors () {
      const errors = []
      if (!this.$v.billingForm.customerInvoicedTotal.$dirty) return errors
      !this.$v.billingForm.customerInvoicedTotal.minValue && errors.push(this.$i18n.t('validations.positive'))
      !this.$v.billingForm.customerInvoicedTotal.decimal && errors.push(this.$i18n.t('validations.number'))
      !this.$v.billingForm.customerInvoicedTotal.required && errors.push(this.$i18n.t('validations.required'))
      return errors
    },
    totalRecords () {
      return this.tableOtherInvoices.data.length
    },
    billingPermissions () {
      return this.$store.state.login.permissions['expenses'].components['billing'].actions
    }
  },
  methods: {
    openGenerateInvoicePanel (item) {
      this.$refs.generateInvoicePanel.openPanel(item)
    },
    formatCurrency,
    loadBillings: async function () {
      this.tableInvoices.loading = true
      try {
        const response = await this.$api.get(`/v1/charges/pos`)
        this.tableInvoices.data = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.tableInvoices.loading = false
    },
    createBilling: async function () {
      this.overlay = true
      try {
        await this.$api.post(`/v1/charges/pos`)
        this.loadBillings()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openUploadDialog (id) {
      this.selectedPos = id
      this.$refs.uploadFileDialog.openUploadDialog()
    },
    resetBillingForm () {
      this.billingForm.customerInvoicedTotal = 0
    },
    setCustomerInvoiceTotalEditOn (value) {
      this.billingForm.customerInvoicedTotal = value
      // item.isEditing = true
    },
    setCustomerInvoiceTotalEditOff (value, item) {
      // item.isEditing = false
      this.resetBillingForm()
    },
    updateCustomerInvoicedTotal: async function (id, amount) {
      const payload = {
        customerInvoicedTotal: Number(amount)
      }
      this.overlay = true
      try {
        await this.$api.put(`/v1/charges/pos/${id}`, payload)
        this.loadBillings()
        this.setCustomerInvoiceTotalEditOff()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    isEmpty,
    openInvoice (invoice) {
      this.$refs.invoiceViewer.open(invoice)
    },
    async loadCategories (params = null) {
      params = params || {
        type: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.categories = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    getCategoryName (id) {
      const category = this.categories.find(item => item._id === id)
      return category ? category.name : undefined
    },
    async loadOtherInvoices () {
      if (this.selectedDates.length === 2) {
        const [startDate, endDate] = this.selectedDates
        const params = {
          'issuedAt>': startDate,
          'issuedAt<': endDate
        }
        this.tableOtherInvoices.loading = true
        try {
          const response = await this.$api.get(`/v1/restaurants/income/invoices`, params)
          this.tableOtherInvoices.data = response.data
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.tableOtherInvoices.loading = false
      }
    },
    updateDates (dates) {
      this.selectedDates = [ ...dates ]
      this.loadOtherInvoices()
    },
    // Todo: set default dates
    // setDefaultDates () {
    //   const nowDate = new Date()
    //   const bottomDate = new Date()
    //   bottomDate.setDate(nowDate.getDate() - 30)

    //   this.selectedDates = [this.$moment(bottomDate).format('YYYY-MM-DD'), this.$moment(nowDate).format('YYYY-MM-DD')]
    // },
    downloadInvoice (id) {
      let url = `${process.env.VUE_APP_API_URL}/v1/invoices/${id}/download-invoice-pdf`
      url += `?access_token=${this.$store.state.login.token}`

      return url
    },
    async markAsPaid (id) {
      this.overlay = true
      try {
        await this.$api.post(`/v1/charges/mark-invoice-as-paid/${id}`)
        this.loadOtherInvoices()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async refreshPosSale (id) {
      this.overlay = true
      try {
        await this.$api.post(`/v1/charges/pos/${id}`)
        this.loadBillings()
        this.setCustomerInvoiceTotalEditOff()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async uploadFile (file) {
      try {
        await this.$api.post(`/v1/charges/pos/${this.selectedPos}/upload`, { csvFile: file }, { delivery: 'formData' })
        this.loadBillings()
        this.$refs.uploadFileDialog.closeUploadDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    downloadLink (item) {
      return `${process.env.VUE_APP_API_URL}/v1/charges/pos/${item._id}/download?access_token=${this.$store.state.login.token}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .paper {
    display: flex;
    padding: 40px 50px 50px 57px;
    border-radius: 26px;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
  }

  .linkButton {
    &:hover {
      a {
        text-decoration: underline;
      }
    }
  }

  .blueButton {
    background-color: #0F6FFF !important;
    color: #fff !important;
  }
</style>

<style lang="scss">
  .tableBilling {
    th {
      font-size: 12px;
    }

    td {
      font-size: 12px;
    }
  }
</style>
